import { Calendar } from "lucide-react"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@atlant/ui"

const YEARS_BACK = 4

interface YearSelectProps {
  value: number
  onChange: (value: number) => void
}

export const YearSelect = ({ value, onChange }: YearSelectProps) => {
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: YEARS_BACK + 1 }, (_, i) => currentYear - i)

  return (
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger className="gap-1.5 border-none text-sm font-medium shadow-none">
        <Calendar className="text-nav-foreground size-4" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start">
        {years.map((year) => (
          <SelectItem key={year} value={String(year)}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
